import React from "react";
import classNames from "classnames";
import FavButton from "./FavButton";

const Listing = (props) => {
    const {
        listing,
        urlBase,
        displayFeatures,
        nofFeaturedListings,
        finderPopup,
        itinerary,
        onClick,
        index,
        categoryMap,
        defaultBlank
    } = props;

    let target = defaultBlank ? '_blank' : '_self';
    let link = `${urlBase}/listing/${listing.URLSegment}`;
    if (listing.Type === 'Event') {
        target = '_blank';
        link = listing.ThirdpartyURL;
    }
    if (listing.CustomLinkListingDirectlyToExternalLink) {
        target = '_blank';
        link = listing.Website;
    }
    if (listing.AbsoluteLink) {
        link = listing.AbsoluteLink;
    }
    if (categoryMap && typeof categoryMap[listing.MainCategory.Identifier] !== "undefined") {
        link = `${categoryMap[listing.MainCategory.Identifier]}/listing/${listing.URLSegment}`;;
    }

    const renderBody = () => {
        return <>
            {!!listing.Featured && <label className="listing-card__featured-label sml">
                Featured
            </label>}
            <div className="listing-card__image"
                 style={{backgroundImage: `url(${listing.MainImage.Sized})` }}>
            </div>
            <div className="listing-card__body">
                {!!listing.Featured && <label className="listing-card__featured-label lrg">
                    Featured
                </label>}
                <h3>{listing.Title}</h3>
                {!!listing.CustomTileDescription && <p>{listing.CustomTileDescription}</p>}
            </div>
        </>
    }

    return <div className={classNames({
        'listing-card': true,
        'listing-card--sm-featured': finderPopup && listing.Featured,
        'listing-card--featured' : (displayFeatures && listing.Featured && !(nofFeaturedListings % 2 === 1 && index + 1 === nofFeaturedListings)),
        'listing-card--featured--single': displayFeatures && listing.Featured && nofFeaturedListings % 2 === 1 && index + 1 === nofFeaturedListings
    })}>
        <FavButton id={listing.Identifier} />
        {!!itinerary && <div
            className={'listing-card__inner'}
            onClick={() => {
                onClick();
            }}
        >
            {renderBody()}
        </div>}
        {!itinerary && <a href={`${link}`} target={target} className="listing-card__inner">
            {renderBody()}
        </a>}
    </div>

}

export default Listing;
